module.exports = __webpack_public_path__ + "js/0.fbaff730.worker.js"